
import firebase from "firebase/app";
require('firebase/firestore')
require('firebase/auth')
require('firebase/storage')
//require('firebase/messaging')

const firebaseConf = {
  apiKey: "AIzaSyAWr4MaQE7JobUDbXO_QOWeYatZaCVCsoQ",
  authDomain: "conf-bakinity1.firebaseapp.com",
  databaseURL: "https://conf-bakinity1-default-rtdb.firebaseio.com",
  projectId: "conf-bakinity1",
  storageBucket: "conf-bakinity1.appspot.com",
  messagingSenderId: "407830326448",
  appId: "1:407830326448:web:e76bb298013d503f7f1f75"
};

firebase.initializeApp(firebaseConf);

export const db = firebase.firestore();

export const auth = firebase.auth();

export const storage = firebase.storage();

//export const messaging = firebase.messaging();

